module.exports = __webpack_public_path__ + "img/common-file-text-clock.2c458c48.svg";